import React from "react";
import {Icon} from "@iconify/react";
import {Image} from "semantic-ui-react";

export const Services = (props) => {
	return (
		<div id="services" className="text-center" style={{"background": "#214150"}}>
			<div className="container">
				<div className="section-title">
					<h2 style={{"color": "#FFFFFF"}}>🎄 Julefrokost 2026</h2>
					<p style={{"color": "#CCDDDD", "fontSize": "18px", "maxWidth": "700px", "margin": "0 auto 20px"}}>
						Fejr julen med kollegaerne eller vennerne i Havens festlige rammer.
						God mad, fri bar og dans hele natten – fra <strong style={{"color": "#F5C518"}}>kun 445,- ex moms pr. person</strong>.
					</p>
					<div style={{"display": "flex", "gap": "12px", "justifyContent": "center", "flexWrap": "wrap", "marginBottom": "30px"}}>
						<span style={{"background": "#F5C518", "color": "#214150", "padding": "6px 16px", "borderRadius": "20px", "fontWeight": "bold", "fontSize": "14px"}}>
							✓ Både firma &amp; privat
						</span>
						<span style={{"background": "#F5C518", "color": "#214150", "padding": "6px 16px", "borderRadius": "20px", "fontWeight": "bold", "fontSize": "14px"}}>
							✓ All Inclusive 995,-
						</span>
						<span style={{"background": "#F5C518", "color": "#214150", "padding": "6px 16px", "borderRadius": "20px", "fontWeight": "bold", "fontSize": "14px"}}>
							✓ Kendt fra Aftenshowet
						</span>
					</div>
				</div>
				<div className="row">
					{props.data
						? props.data.map((d, i) => (
							<div key={`${d.name}-${i}`} className="col-md-4">
								{" "}
								<Icon icon={d.icon} style={{ fontSize: '8em', color: "#F5C518" }} />
								<div className="service-desc">
									<h3 style={{"color": "#FFFFFF"}}>{d.name}</h3>
									<p style={{"color": "#CCDDDD"}}>{d.text}</p>
								</div>
							</div>
						))
						: "loading"}
				</div>
				<div className="row" style={{"marginTop": "30px"}}>
					<a href='/julefrokost.html' target='_blank' rel='noopener noreferrer'>
						<Image wrapped={true} centered={true} src="/pdf/Haven_Julefrokost 2026_A4-1.png" size="large"
							style={{"borderRadius": "8px", "boxShadow": "0 8px 32px rgba(0,0,0,0.5)", "cursor": "pointer"}}/>
					</a>
					<p style={{"color": "#AABBCC", "marginTop": "12px", "fontSize": "14px"}}>Klik på menuen for at se den i fuld størrelse</p>
				</div>
				<div style={{"marginTop": "30px", "paddingBottom": "20px"}}>
					<a href="#contact" className="btn btn-lg page-scroll"
						style={{"background": "#F5C518", "color": "#214150", "fontWeight": "bold", "border": "none", "padding": "14px 40px", "fontSize": "18px", "borderRadius": "4px"}}>
						Book julefrokost nu
					</a>
				</div>
			</div>
		</div>
	);
};
